import { render, staticRenderFns } from "./totalizador.vue?vue&type=template&id=785d7fdf"
import script from "./totalizador.vue?vue&type=script&lang=js"
export * from "./totalizador.vue?vue&type=script&lang=js"
import style0 from "./totalizador.vue?vue&type=style&index=0&id=785d7fdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports